import type React from 'react';

import { OrdCreateInDialogButton, OrdEditInDialogButton } from '@ragu-components/ord-components';
import { ExtensionUpdateFields, PermissionFields } from '@ragu-components/ord-types';
import { RecordContextProvider, ReferenceManyField, WrapperField } from 'react-admin';

import { ExtensionsForm } from '../extensions/ExtensionsForm';
import { ExtensionList } from '../extensions/ExtensionsList';

import type { UserRead } from '@ragu-components/ord-types';

export const UserExtensionsTab = ({ user }: { user: UserRead }): React.ReactElement => {
  const createButton = (
    <OrdCreateInDialogButton inline fullWidth>
      <ExtensionsForm defaultValues={{ user: user.id }} />
    </OrdCreateInDialogButton>
  );

  const editButton = (
    <OrdEditInDialogButton mutationMode='pessimistic' fullWidth>
      <ExtensionsForm deleteProps={{ redirect: false }} />
    </OrdEditInDialogButton>
  );

  return (
    <RecordContextProvider value={user}>
      <ReferenceManyField target={`${ExtensionUpdateFields.user}.id`} reference={PermissionFields.extensions}>
        <ExtensionList
          embeddedChildren={<WrapperField label={createButton}>{editButton}</WrapperField>}
          layout='embedded'
          empty={createButton}
        />
      </ReferenceManyField>
    </RecordContextProvider>
  );
};
